export default __webpack_public_path__ + "static/media/icono_doctor.3edfaa44.svg";